// extracted by mini-css-extract-plugin
export default {"root":"ntr3PzTIXP09jWeCJ7so","arrowBorder":"XhAcveKlo__3HXTiBHVg","arrow":"llCJEeTWv8oXTKyVM60H","active":"iBlQiFl6odNLGaet3Ysz"};